<div class="bg-white">

  <!-- Filters -->
  <section aria-labelledby="filter-heading" class="grid items-center border-t border-[#dfe0ff] dark:border-[#3b4377]">
    <h2 id="filter-heading" class="sr-only">Filters</h2>
    <div class="relative col-start-1 row-start-1" [ngClass]="{'py-[0.68rem]': getActiveFilters().length > 0, 'py-4': getActiveFilters().length === 0}">
      <div class="mx-auto flex items-center space-x-6 divide-x divide-gray-200 px-4 text-sm sm:px-6 lg:px-6">
        <div>
          <button type="button" class="group flex items-center font-medium text-gray-700" aria-controls="disclosure-1" aria-expanded="false" (click)="toggleFilters()">
            <svg class="mr-2 h-5 w-5 flex-none text-gray-400 group-hover:text-gray-500" aria-hidden="true" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 01.628.74v2.288a2.25 2.25 0 01-.659 1.59l-4.682 4.683a2.25 2.25 0 00-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 018 18.25v-5.757a2.25 2.25 0 00-.659-1.591L2.659 6.22A2.25 2.25 0 012 4.629V2.34a.75.75 0 01.628-.74z" clip-rule="evenodd" />
            </svg>

            <div class="flex items-center">
              {{ getActiveFilters().length > 0 ? getActiveFilters().length : '' }}
              {{ getActiveFilters().length === 1 ? 'Filter' : 'Filters' }}
            </div>

          </button>
        </div>
        <div class="pl-6">

          <div class="flex">

            <!-- Active Filters -->
            <div class="pr-2">
              <div class="-m-1 flex flex-wrap items-center">
                <span *ngFor="let filter of getActiveFilters()" class="m-1 inline-flex items-center rounded-full border border-gray-200 bg-white py-1 pl-3 pr-2 text-sm font-medium text-gray-900">
                  <span>{{ filter.label }}</span>
                  <button type="button" class="ml-1 inline-flex h-4 w-4 flex-shrink-0 rounded-full p-1 text-gray-400 hover:bg-gray-200 hover:text-gray-500" (click)="removeFilter(filter.category, filter.value)">
                    <span class="sr-only">Remove filter for {{ filter.label }}</span>
                    <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                      <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                    </svg>
                  </button>
                </span>
              </div>
            </div>

            <button *ngIf="getActiveFilters().length > 0" type="button" class="text-gray-500 flex items-center" (click)="clearAllFilters()">
              Clear all
            </button>

          </div>

        </div>
      </div>
    </div>

    <div [ngClass]="{'hidden': !filtersOpen, 'block': filtersOpen, 'transition': true, 'duration-500': true}" class="border-t border-gray-200 py-10" id="disclosure-1">
      <div class="mx-auto grid grid-cols-2 gap-x-4 px-4 text-sm sm:px-6 md:gap-x-6 lg:px-8">
        <div class="grid auto-rows-min grid-cols-1 gap-y-10 md:grid-cols-3 md:gap-x-6">
          <!-- Filters content here -->

          <!-- Role Filter -->
          <fieldset>
            <legend class="block font-medium">Role</legend>
            <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
              <div *ngFor="let role of filterOptions.roles" class="flex items-center text-base sm:text-sm">
                <input [id]="'role-' + role.value" [name]="'roles[]'" [value]="role.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                       [checked]="isSelected('roles', role.value)"
                       (change)="onFilterChange('roles', role.value, $event)">
                <label [for]="'role-' + role.value" class="ml-3 min-w-0 flex-1 text-gray-600">{{ role.label }}</label>
              </div>
            </div>
          </fieldset>

          <!-- Deal Stage Filter -->
          <fieldset>
            <legend class="block font-medium">Deal Stage</legend>
            <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
              <div *ngFor="let stage of filterOptions.dealStages" class="flex items-center text-base sm:text-sm">
                <input [id]="'deal-stage-' + stage.value" [name]="'dealStages[]'" [value]="stage.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                       [checked]="isSelected('dealStages', stage.value)"
                       (change)="onFilterChange('dealStages', stage.value, $event)">
                <label [for]="'deal-stage-' + stage.value" class="ml-3 min-w-0 flex-1 text-gray-600">{{ stage.label }}</label>
              </div>
            </div>
          </fieldset>

          <!-- Deal Value Filter -->
          <fieldset>
            <legend class="block font-medium">Deal Value</legend>
            <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
              <div *ngFor="let value of filterOptions.dealValues" class="flex items-center text-base sm:text-sm">
                <input [id]="'deal-value-' + value.value" [name]="'dealValue[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                       [checked]="isSelected('dealValues', value.value)"
                       (change)="onFilterChange('dealValues', value.value, $event)">
                <label [for]="'deal-value-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600">{{ value.label }}</label>
              </div>
            </div>
          </fieldset>

        </div>

        <div class="grid auto-rows-min grid-cols-1 gap-y-10 md:grid-cols-3 md:gap-x-6">

          <!-- Status Filter -->
          <fieldset>
            <legend class="block font-medium">Status</legend>
            <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
              <div *ngFor="let value of filterOptions.statuses" class="flex items-center text-base sm:text-sm">
                <input [id]="'status-' + value.value" [name]="'statuses[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                       [checked]="isSelected('statuses', value.value)"
                       (change)="onFilterChange('statuses', value.value, $event)">
                <label [for]="'status-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600">{{ value.label }}</label>
              </div>
            </div>
          </fieldset>

        </div>

      </div>
    </div>

    <!--
    <div class="col-start-1 row-start-1 py-4">
      <div class="mx-auto flex justify-end px-4 sm:px-6 lg:px-6">
        <div class="relative inline-block">
          <div class="flex">
            <button type="button" class="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900" id="menu-button" aria-expanded="false" aria-haspopup="true" (click)="toggleSort()">
              Sort
              <svg class="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
          <div [ngClass]="{'hidden': !sortOpen, 'block': sortOpen, 'transition': true, 'duration-500': true}" class="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
            <div class="py-1" role="none">
              <a href="#" class="block px-4 py-2 text-sm font-medium text-gray-900" role="menuitem" tabindex="-1" id="menu-item-0">Most Popular</a>
              <a href="#" class="block px-4 py-2 text-sm text-gray-500" role="menuitem" tabindex="-1" id="menu-item-1">Best Rating</a>
              <a href="#" class="block px-4 py-2 text-sm text-gray-500" role="menuitem" tabindex="-1" id="menu-item-2">Newest</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->

  </section>
</div>
